import { USER_ROLE } from './ids'

export const ROLE_NAMES = {
  [USER_ROLE.USER]: 'User',
  [USER_ROLE.SUPER_ADMIN]: 'Super Admin',
}

export const LONG_DASH = '—'
